export const required = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0 ? undefined : 'Required';
  }

  if (typeof value === 'object') {
    return Object.keys(value).length > 0 ? undefined : 'Required';
  }

  if (typeof value === 'number') {
    return undefined;
  }

  return value ? undefined : 'Required';
}

export default null;


// WEBPACK FOOTER //
// ./src/lib/formValidations.js